<template>
  <!-- <ProductDetailsHeader /> -->
  <div class="thankcover-success pb-5 mx-auto">
    <div class="container">
      <div class="row justify-content-center">
      <div class="col-md-8 col-12">
      <div class="shadow-sm p-2 rounded mt-3 mb-4 product_details product_details-header d-flex flex-wrap justify-content-between align-items-center gap-3 border-1 mx-0 w-100" v-if="selectedPlanData != undefined && paymentPollingStatus && applicationNumber">
      <div class="gap-3">
        <img :src="selectedPlanData.supportingData.insCompanyLogo" alt="" width="120" height="auto" style="background:white; border-radius: 10px; padding: 5px;">
        <!-- <p class="mb-0 insurer_name">{{selectedPlanData.insuranceAndProducts.insuranceCompanyName}}</p> -->
      </div>
      <div>
        <JourneyIdContainer :journey-id="journeyId" label="JOURNEY ID :" />
      </div>
    </div>
        <div class="thank-you thankyou_payment_success rounded">
        <!-- Policy Issued Section -->
        <div v-if="policy_status === 'Policy Issued'" class="text-center" >
          <img src="/images/successGif.gif" class="m-auto success_gif" />
          <h4 class="text-center text-success mt-3">Payment Successful !</h4>
          <h4 v-if="applicationStatus !== 'Policy Issued'" class="text-center text-black">
            Thank you for buying the {{carType}} policy.
          </h4>
          <h4 v-else class="text-center text-black">
            Thank you for buying the {{carType}} policy.
          </h4>
          <h4 class="text-center">
            Your proposal is submitted successfully to insurance company and the details are shown below:
          </h4>
          <!-- <div class="row justify-content-center mt-4">
            <div class="col-md-3 col-lg-3 col-sm-12 col-xs-12">
              <div class="headingcards" v-if="policy_status === 'Policy Issued'">
                <div class="mb-3 d-flex gap-2 justify-content-center">
                  <p class="alignment">Policy Number</p>
                  <h3 class="alignment">{{ policyNo }}</h3>
                </div>
                <button
                  class="btn commonButton"
                  @click="downloadPdf()"
                  :disabled="setBtnFlag"
                >
                  Download Policy
                </button>
              </div>
            </div>
          </div> -->
        </div>

        <!-- Scrutiny Section -->
        <div v-else-if="policy_status === 'Scrutiny'" class="text-center" style="width: 100%; margin-inline: auto">
          <img src="/images/successGif.gif" class="m-auto" />
          <h4 class="text-center text-success mt-3">Payment Successful!</h4>
          <p class="text-center">
            <h4>An inspection has been triggered for your policy.</h4>
            <h4>The insurer will connect with you to take this forward.</h4>
          </p>
          <div class="row justify-content-center mt-4">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12" v-if="!policyNo && applicationNumber">
              <div v-if="applicationNumber" class="headingcards mx-auto" style="width: 380px">
                <CopyToClipboard :label="'Proposal Number'" :copyValue="applicationNumber" :checkValid="false" :hasLabel="true"/>

                <!-- <div class="mb-0 d-flex gap-2 align-items-center justify-content-center flex-wrap">
                  <h3 class="alignment mb-0">Proposal Number:</h3>
                  <h3 class="alignment mb-0" style="line-break: anywhere">{{ applicationNumber ? applicationNumber.replaceAll('"', '') : applicationNumber }}</h3>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Underwriting Section -->
        <div v-else-if="policy_status === 'Underwriting'" class="text-center" style="width: 100% ; margin-inline: auto">
          <img src="/images/successGif.gif" class="m-auto" />
          <h4 class="text-center text-success mt-3">Payment Successful!</h4>
          <p class="text-center">
    <b>        Thank you for buying the {{carType}} policy.
    </b>      </p>
          <p class="text-center">
            Your proposal is submitted successfully to insurance company and the details are shown below:
          </p>
          <div class="row justify-content-center mt-4">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div v-if="applicationNumber" class="headingcards mx-auto" style="width: 380px">
                <CopyToClipboard :label="'Proposal Number'" :copyValue="applicationNumber" :checkValid="false" :hasLabel="true"/>
                <!-- <div class="mb-0 d-flex gap-2 align-items-center justify-content-center flex-wrap">
                  <h3 class="alignment mb-0">Proposal Number:</h3>
                  <h3 class="alignment mb-0" style="line-break: anywhere">{{ applicationNumber ? applicationNumber.replaceAll('"', '') : applicationNumber }}</h3>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="py-3 px-3 rounded mt-3 mb-4 product_details product_details01 border-1" v-if="selectedPlanData != undefined && paymentPollingStatus && applicationNumber" style="width: 100%;">
          <div class="product01" style="width: 100%;">
            <p class="mb-2">
              <span>Plan Name</span>
              <strong>{{ selectedPlanData?.productDetails?.planOption?.planName?.toUpperCase() }}</strong>
            </p>
            <p class="mb-2" v-if="policyNo && !isInvalid(policyStartDate)">
              <span>Policy Start Date</span>
              <strong>{{policyStartDate ? formatDateToMonthString(policyStartDate) : 'NA'}}</strong>
            </p>
            <p class="mb-2">
              <span>Final Premium</span>
              <div class="eye-icon d-flex gap-2 align-items-center">
                <strong clas>₹ {{formatToINR(manufacturerPayment)}}</strong>
                <img src="@/assets/images/eyeicon.svg" width="24" height="auto" @click="showBreakupmodal()"/>
                <p class="premium_breakup">Premium Breakup</p>
              </div>
            </p>
            <p class="mb-2" v-if="policyNo && !isInvalid(policyEndDate)">
              <span>Policy End Date</span>
              <strong>{{policyEndDate ? formatDateToMonthString(policyEndDate) : 'NA'}}</strong>
            </p>
            <p class="mb-0">
              <span>Registration No.</span>
              <strong v-if="selectedPlanData && selectedPlanData.insuranceAndProducts.policyTypeDesc=='New'">NEW</strong>
              <strong v-else>{{registrationNo ? (registrationNo).toUpperCase() : 'NA'}}</strong>
            </p>
            <p class="mb-0" v-if="policyStatusLabel">
              <span>Policy Status</span>
              <span :class="{
                'pending_status': policyStatusLabel === 'Scrutiny',
                'success_status': policyStatusLabel === 'Policy Issued',
                'underwriting_status': policyStatusLabel === 'Underwriting',
              }">{{
                policyStatusLabel === 'Underwriting'
                  ? 'UNDERWRITING'
                  : policyStatusLabel === 'Scrutiny'
                    ? 'INSPECTION REQUIRED'
                    : policyStatusLabel === 'Policy Issued'
                      ? 'POLICY ISSUED'
                      : policyStatusLabel
              }}</span>
            </p>
            <p class="mt-3" v-if="customerName">
              <span>{{isCorporateJourney ? 'Company Name' : 'Customer Name'}}</span>
              <strong>{{ this.customerName.toUpperCase() }}</strong>
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center" v-if="!isInvalid(policyNo)">
          <CopyToClipboard :label="'Policy Number'" :copyValue="policyNo" :checkValid="true" :hasLabel="true"/>
          <button
          class="btn commonButton mb-2 align-self-end w-50"
          @click="downloadPolicy()"
          >
          {{ isDownloading ? "Generating PDF to download..." : "Download Policy" }}
          </button>
        </div>
        <div class="error_container">
          <p class="error-text mb-0" style="color: #F00 !important; line-break: anywhere;" v-show="downloadError.length>0" v-for="msg in downloadError" :key="msg">{{msg}}</p>
        </div>
    </div>
      </div>
    </div>
    </div>
    <Disclaimer :page="'ThankYou'"/>
    <AmountBreakup v-if="this.openAmountBreakupflag" @emitClose="emitClose()" :selectedPlanData="selectedPlanData"/>
    <!-- <pageLoader :msg="loadingMessage" v-if="loadingState" /> -->
  </div>
 
</template>
  <script>
  import CopyToClipboard from "../uiResuable/CopyToClipBoard.vue"
import ProductDetailsHeader from '../productDetailsHeader/ProductDetailsHeader.vue';
import AmountBreakup from "@/modals/amountBreakup.vue";
import Disclaimer from "@/components/uiResuable/Disclaimer.vue"
import pageLoader from "../pageLoaders/pageLoader.vue";

  export default {
    components:{
      ProductDetailsHeader,
      AmountBreakup,
      CopyToClipboard,
      Disclaimer
    },
  data(){
    return{
    policyNo: "",
    journeyId:"",
    policy_status:"",
    applicationStatus:"",
    isDownloading: false,
    applicationNumber: "",
    selectedPlanData: sessionStorage.getItem("selected_plan_data") && JSON.parse(sessionStorage.getItem("selected_plan_data")),
    manufacturerPayment: "",
    paymentPollingStatus: sessionStorage.getItem("payment_poll_status") && JSON.parse(sessionStorage.getItem("payment_poll_status")) ,
    policyStartDate: "",
    policyEndDate: "",
    copySuccess: false,
    manufacturerPaymentObj: "",
    registrationNo: "",
    carType: "",
    downloadError: [],
    policyPdf: null,
    customerName: "",
    chassisNumber: "",
    isCorporateJourney: false,
    openAmountBreakupflag: false,
    // loadingMessage: "",
    // loadingState: false
  };
},
  mounted(){
    if(sessionStorage.getItem("pay_response")) {
      this.payResponse = JSON.parse(sessionStorage.getItem("pay_response"));
    }
    if(sessionStorage.getItem("policy_status") && sessionStorage.getItem("policy_status") !== "undefined") {
      this.policy_status = JSON.parse(sessionStorage.getItem("policy_status"));
      console.log(">>>>>>>>>>",this.policy_status)
    }
    if(sessionStorage.getItem("journey_id")){
      this.journeyId = JSON.parse(sessionStorage.getItem("journey_id"));
    }
    if(sessionStorage.getItem("policyNo") && sessionStorage.getItem("policyNo") != '') {
        this.policyNo = sessionStorage.getItem("policyNo");
    }
    if(sessionStorage.getItem("applicationNumber") && sessionStorage.getItem("applicationNumber") != '') {
        this.applicationNumber = JSON.parse(sessionStorage.getItem("applicationNumber"));
        this.applicationNumber = this.applicationNumber ? this.applicationNumber.replaceAll('"', '') : this.applicationNumber;
    }
    if(sessionStorage.getItem("applicationStatus")){
      this.applicationStatus=JSON.parse(sessionStorage.getItem("applicationStatus"));
      console.log("this.applicationStatus",this.applicationStatus)

    }
    if(this.policy_status=="Policy Issued"){
      this.downloadPolicy();
    }
    let filledData = null;
    try {
      filledData = JSON.parse(sessionStorage.getItem("filledData"));
    } catch {
      filledData = null;
    }
    let propsalReviewedObj = null;
    try {
      propsalReviewedObj = JSON.parse(sessionStorage.getItem("propsalDetails_review"));
    } catch {
      propsalReviewedObj = null;
    }
    this.isCorporateJourney = propsalReviewedObj?.quote_request?.quote_request_json?.personalInformation?.individualDetails?.[0]?.ownerBelongsToOrganizationFlag == true;
    this.customerName = this.isCorporateJourney
      ? (filledData?.fieldGroups?.proposerDetails?.fieldGroups?.corporateDetails?.fields?.nameOfCaompany?.input || '')
      : (filledData?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields?.fullName?.input || '');
    try {
      this.manufacturerPaymentObj = JSON.parse(sessionStorage.getItem("manufacturer_paymentStatus"));
    } catch {
      this.manufacturerPaymentObj = null;
    }
    this.carType = this.manufacturerPaymentObj?.productCode?.includes('2W')
      ? 'Two Wheeler'
      : this.manufacturerPaymentObj?.productCode?.includes('4W')
        ? 'Private Car'
        : '';
    let propsalSubmitedObj = null;
    try {
      propsalSubmitedObj = JSON.parse(sessionStorage.getItem("propsalSubmited_afterPayment"));
    } catch {
      propsalSubmitedObj = null;
    }
    this.policyStartDate = this.manufacturerPaymentObj?.policyDetails?.policyEffectiveDate
      || propsalReviewedObj?.proposal?.proposal_response?.policy?.policyStartDate
      || "NA";
    
    this.policyEndDate = this.manufacturerPaymentObj?.policyDetails?.policyEndDate
      || propsalReviewedObj?.proposal?.proposal_response?.policy?.policyEndDate
      || "NA";
    const quoteCategory = propsalReviewedObj?.quote_request?.quote_request_json?.quoteCategory;
    this.registrationNo = quoteCategory == "New"
      ? (propsalReviewedObj?.quote_request?.quote_request_json?.product?.rtoLocationCode || '')
      : (propsalReviewedObj?.quote_request?.quote_request_json?.product?.registrationDetails?.registrationNumber || '');
    if(sessionStorage.getItem("manufacturer_paymentStatus") && this.manufacturerPaymentObj){
      this.manufacturerPayment = this.manufacturerPaymentObj?.premiumStatus?.[0]?.totalPremiumPaid;
    }
    if (!this.manufacturerPayment) {
      this.manufacturerPayment = propsalSubmitedObj?.totalPremiumDetails?.[0]?.totalPremiumWithTax
        || propsalSubmitedObj?.productDetails?.totalPremiumDetails?.[0]?.totalPremiumWithTax
        || '';
    }
    if (!this.manufacturerPayment) {
      this.manufacturerPayment =
        this.selectedPlanData?.productDetails?.totalPremiumDetails?.[0]?.totalPremiumWithTax
        || this.selectedPlanData?.totalPremiumDetails?.[0]?.totalPremiumWithTax
        || '';
    }
    // Re-read plan from session if component still has stale/empty selectedPlanData
    if (!this.manufacturerPayment) {
      try {
        const planFresh = JSON.parse(sessionStorage.getItem('selected_plan_data'));
        this.manufacturerPayment =
          planFresh?.productDetails?.totalPremiumDetails?.[0]?.totalPremiumWithTax
          || planFresh?.totalPremiumDetails?.[0]?.totalPremiumWithTax
          || '';
        if (planFresh && !this.selectedPlanData) {
          this.selectedPlanData = planFresh;
        }
      } catch {
        /* ignore */
      }
    }
    if (!this.carType && this.selectedPlanData?.insuranceAndProducts?.productCode) {
      const code = this.selectedPlanData.insuranceAndProducts.productCode;
      this.carType = code.includes('2W') ? 'Two Wheeler' : code.includes('4W') ? 'Private Car' : '';
    }
   
  },
  computed: {
    policyStatusLabel() {
      return (
        this.manufacturerPaymentObj?.policyDetails?.policyStatus
        || this.policy_status
        || ''
      );
    },
  },
  methods:{
    premiumRound(amount){
      return Math.round(amount);
    },
    isInvalid(value) {
      const trimmed = typeof value === 'string' ? value.trim().toLowerCase() : value;
      return (
        trimmed === null ||
        trimmed === undefined ||
        trimmed === false ||
        trimmed === 0 ||
        trimmed === '' ||
        trimmed === 'null' ||
        trimmed === 'undefined' ||
        trimmed === 'false' ||
        (Array.isArray(trimmed) && trimmed.length === 0) ||
        (typeof trimmed === 'object' && !Array.isArray(trimmed) && Object.keys(trimmed).length === 0)
      );
    },
    emitClose() {
      this.openAmountBreakupflag = false;
    },
    showBreakupmodal() {
      this.openAmountBreakupflag = true;
    },
    downloadPolicy() {
      this.isDownloading = true;
      this.downloadError = [];
      console.log('downloadPolicy called: ');
      this.loading2 = true;
      let headers = {};
      const qData = [this.journeyId];

      this.backendApi("downloadPolicy", qData, headers, "get")
        .then((response) => {
          this.loading2 = false;
          this.isDownloading = false;
         
          if (response.status == "error") {
            let msg = [response.data.detail];
            this.downloadError = msg;
            
          } else if(response?.data?.errors?.length>0) {
            let msg = [];
            if(this.policyNo && (!response?.data?.data?.file || !response?.data?.data)) {
              msg.push('Policy Copy is still not available for Download. Please try after some time.');
            } else if(this.applicationNumber && !this.policyNo){
              msg.push('Policy is still with Underwriting. Please try after some time.');
            }
            
            response?.data?.errors.forEach(err => {
              if(err.errorDisplayMessage) {
                this.downloadError.push(err.errorDisplayMessage);
              }
            });
            
            if(msg.length > 0) {
              this.downloadError = [...this.downloadError, ...msg];
            }
            
          } else {
            this.policyPdf = response.data.data;
            
            // If PDF is available, automatically download it
            if(this.policyPdf && this.policyPdf.file) {
              this.downloadPdf();
            }else if(this.policyPdf && this.policyPdf.fileName){
              this.openPdfInNewTab();
            }
            else {
              this.downloadError.push('No policy file available for download.');
            }
          }
        })
        .catch((error) => {
          console.log('error msg block : get policy', error);
          this.loading2 = false;
          this.isDownloading = false;
          this.downloadError = ['We are facing some issue while downloading policy'];
        });
    },
    copyToClipboard(copytext){
      navigator.clipboard.writeText(copytext)
        .then(() => {
          this.copySuccess = true;
          setTimeout(() => {
            this.copySuccess = false;
          }, 2000);
        })
        .catch(err => console.error("Failed to copy text: ", err));
    },
    formatDateToMonthString(dateStr) {
      if (!dateStr) return 'NA';

      let date;

      if (dateStr.includes('/')) {
          const [day, month, year] = dateStr.split('/').map(Number);
          date = new Date(year, month - 1, day);
      } else if (dateStr.includes('-') && dateStr.length === 10) {
          const [year, month, day] = dateStr.split('-').map(Number);
          date = new Date(year, month - 1, day);
      } else {
          date = new Date(dateStr);
      }

      if (isNaN(date.getTime())) return 'NA';

      const day = date.getDate().toString().padStart(2, '0');
      const shortMonth = date.toLocaleString('en-US', { month: 'short' });
      const year = date.getFullYear();

      return `${day}-${shortMonth}-${year}`.toUpperCase();
    },
    currency(amt) {
      const tmpAmt = parseFloat(amt).toFixed(2);
      return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatIndianCurrency(num) {
      let [integerPart, decimalPart] = num.toString().split("."); // Split into integer and decimal parts
      let lastThree = integerPart.slice(-3);
      let rest = integerPart.slice(0, -3);

      if (rest !== '') {
          rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      }
      let formattedDecimal = decimalPart ? "." + parseFloat("0." + decimalPart).toFixed(2).split(".")[1] : "";
      return rest !== '' ? rest + ',' + lastThree + formattedDecimal : lastThree + formattedDecimal;
    },
    downloadPdf() {
      // Check if we already have the PDF data
      // if (!this.policyPdf || !this.policyPdf.file) {
      //   // If no PDF data, call the API to get it first
      //   this.downloadPolicy();
      //   return;
      // }
      if(this.policyPdf.file){
        try {
          const byteCharacters = window.atob(this.policyPdf.file);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);

          // 1. Open PDF in new tab
          window.open(blobUrl, '_blank');

          // 2. Download the PDF
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = this.policyNo || "policy.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Optional: revoke blob URL after a short delay to free memory
          setTimeout(() => window.URL.revokeObjectURL(blobUrl), 10000);
        } catch (error) {
          console.error("Error downloading PDF:", error);
          this.downloadError = ['Error while downloading the PDF. Please try again later.'];
        }
      }else{
        this.openPdfInNewTab();
      }
    },
    async openPdfInNewTab(){
      // if (!this.policyPdf || !this.policyPdf.fileName) {
      //   this.downloadPolicy();
      //   return;
      // }

      try {
        window.open(this.policyPdf.fileName, "_blank");
      } catch (error) {
        this.downloadError = ['Error while opening the PDF on new tab. Please try again later.'];
      }
    }
  },

  };
  </script>
  <style lang="scss">
 @import "../../assets/scss/components/Loaders.scss";
 .insurer_name{
  width: unset !important;
  min-width: unset !important;
 }
  </style>